import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetRatePlanRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetRatePlanResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setRatePlan = (request: SetRatePlanRequest, options?: CashRequestOptions) =>
  post<SetRatePlanRequest, SetRatePlanResponse>('/2.0/cash/set-rate-plan', request, { ...options, rejectOnError: true })
